enum ContactDuplicateReasonType {
  Name = 'Name',
  Email = 'Email',
  PhoneNumber = 'PhoneNumber',
  MobilePhoneNumber = 'MobilePhoneNumber',
}

export default ContactDuplicateReasonType;
